import { Injectable } from "@angular/core";
import { Store } from "@ngxs/store";
import { take } from "rxjs/operators";
import { IPharmacy } from "src/app/shared/interfaces/pharmacy.interface";
import { SaveSupplierBuyer } from "src/app/shared/states/orders/orders.actions";
import { OrdersState } from "src/app/shared/states/orders/orders.state";
import { PharmacyState } from "src/app/shared/states/pharmacy/pharmacy.state";
import { OrderPartyDetail, OrderPartyTypeEnum } from "../interfaces/order-party-details.interface";
import { deepCopy } from "src/app/shared/helpers/helpers";

@Injectable()
export class BuyerSupplierService {
    /**
     *
     */
    constructor(private store: Store) {  }

    createDefaultSupplierOrEdiBuyer(type: OrderPartyTypeEnum = OrderPartyTypeEnum.Supplier): Promise<OrderPartyDetail> {
        const currentPharmacy = this.store.selectSnapshot(PharmacyState.currentPharmacy) as IPharmacy;
            const supplier = {
              deaNumber: currentPharmacy.deaNumber,
              physicalAddress: {
                address1: currentPharmacy.street,
                city: currentPharmacy.city,
                state: currentPharmacy.state,
                zipCode: currentPharmacy.zipCode
              },
              shippingAddress: {
                address1: currentPharmacy.street,
                city: currentPharmacy.city,
                state: currentPharmacy.state,
                zipCode: currentPharmacy.zipCode
              },
              orderParty: {
                pharmacyID: currentPharmacy.id,
                companyName: currentPharmacy.name,
                type: type
              }
            } as OrderPartyDetail;

        return new Promise((resolve, reject) => {
            this.store
                .dispatch(new SaveSupplierBuyer(supplier))
                .pipe(take(1))
                .subscribe({
                 next: () => {
                    const copy = deepCopy(supplier);
                    const selected = this.store.selectSnapshot(OrdersState.addedModifiedOrderParty);
                    if (selected) {
                    copy.id = selected.orderPartyDetailID;
                    copy.orderPartyID = selected.orderPartyID;
                    copy.orderParty.id = selected.orderPartyID;
                    resolve(copy);
                    }
                },
                error: (err) => {
                    reject(err);
                }
            });
        });
    }
}

